<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .bullet-points {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);

    .bullet {
      @include mixins.h3();
      display: flex;
      gap: utils.in_rem(24px);
      align-items: center;
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";

  const bulletPoints = [
    {
      icon: "far fa-list-check",
      text: "Never forget an action item",
    },
    {
      icon: "far fa-rocket",
      text: "Focus on conversations, not writing notes",
    },
    {
      icon: "far fa-right-left-large",
      text: "Send summaries straight into your ATS or CRM",
    },
  ];

  const iconProps = {
    color: "activityReply_50",
    backgroundColor: "activityReply_5",
  };
</script>

<div class="bullet-points">
  {#each bulletPoints as bullet}
    <div class="bullet">
      <IconScale {...{ ...iconProps, class: bullet.icon }} />
      <span>{bullet.text}</span>
    </div>
  {/each}
</div>
